import React from 'react';
import PropTypes from 'prop-types';

import {
  Dropdown,
} from 'semantic-ui-react';

import _ from 'lodash';
import { compose } from 'recompose';

import hasUserInfo from '../../hocs/has-user-info';
import hasRESTClient from '../../hocs/has-rest-client';

class TagsSelector extends React.Component {
  //
  constructor(props) {
    super(props);
    this.state = {
      options: [],
      isLoading: false,
    };
  }

  async componentDidMount() {
    const { restClient, userInfo: { organisationId }, onSelected } = this.props;
    const response = await restClient.get(`tags?filter[organisation]=${organisationId}`);
    const tags = _.get(response, 'data.data', []);
    const options = _.map(tags, tag => ({
      key: _.get(tag, 'id'),
      value: _.get(tag, 'id'),
      text: _.get(tag, 'attributes.value'),
      onClick: () => onSelected(_.get(tag, 'id'), tags),
    }));
    this.setState({
      isLoading: false,
      options,
    });
  }

  render() {
    const { selectedTags, onUnselected } = this.props;
    const { options, isLoading } = this.state;
    return (
      <Dropdown
        placeholder="Select tags"
        fluid
        loading={isLoading}
        search
        selection
        multiple
        options={options}
        value={selectedTags}
        onLabelClick={(event, { value }) => onUnselected(value)}
      />
    );
  }
}

TagsSelector.propTypes = {
  onSelected: PropTypes.func.isRequired,
  onUnselected: PropTypes.func.isRequired,
  selectedTags: PropTypes.func.isRequired,
};

export default compose(
  hasRESTClient,
  hasUserInfo,
)(TagsSelector);



/** WEBPACK FOOTER **
 ** ./src/components/tags-selector/index.js
 **/